import React, { useEffect } from 'react'

const ensureHotjarInitialized = (hjid: number) => {
  const w = window as unknown as {
    hj?: unknown
    _hjSettings?: { hjid: number; hjsv: number }
    __hotjarInitialized?: boolean
    __hotjarSiteId?: number
  }

  if (w.__hotjarInitialized || w.hj || document.querySelector('script[data-hotjar-script="true"]')) {
    return
  }
  ;(w as unknown as { hj: (...args: unknown[]) => void }).hj = function (...args: unknown[]) {
    const fn = (w as unknown as { hj: { q?: unknown[][] } }).hj
    fn.q = fn.q || []
    fn.q.push(args)
  }

  w._hjSettings = { hjid, hjsv: 6 }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://static.hotjar.com/c/hotjar-${hjid}.js?sv=${w._hjSettings.hjsv}`
  script.dataset.hotjarScript = 'true'
  document.head.appendChild(script)

  w.__hotjarInitialized = true
  w.__hotjarSiteId = hjid
}

export const HotjarBootstrap: React.FC = () => {
  const siteId = import.meta.env.REACT_APP_HOTJAR_SITE_ID
  const hjid = siteId ? Number(siteId) : null

  useEffect(() => {
    if (!hjid || !Number.isFinite(hjid)) {
      return
    }
    ensureHotjarInitialized(hjid)
  }, [hjid])

  return null
}
